// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"964":"product","3957":"get-vehicle-picker"}[chunkId] + ".css";
};